import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { objectToPath} from "../utils/Utils";
import { apiCall } from "../utils/Api";
import { Divider, Segmented, Space, Spin, Typography, Layout, Table, Button, message, Checkbox } from "antd";
import { CloseOutlined, PicLeftOutlined, UnorderedListOutlined } from '@ant-design/icons';
import BrowseFilters from "./BrowseFilters";
import Paginate from "./Paginate";
import Renderer from "./Renderer";
import BusinessContactInfo from "./BusinessContactInfo";

export default function BusinessDirectory() {

    const path = "/business-directory";
    const history = useHistory();
    const loc = useLocation();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState({ rows: [] });
    const [filters, setFilters] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [view, setView] = useState("list");
    const count = results?.row_count || 0;
    const [pagination, setPagination] = useState(() => {
        const offset = 0;
        const limit = 26;
        return {
            current: Math.floor(offset / limit) + 1,
            offset,
            pagesize: limit
        };
    });

    const parseURL = (_url, _map = true) => {
        const mapping = {
            e: "category",
            s: "specialty",
            c: "city",
            p: "province",
            f: "country",
            t: "search_term",
            l: "limit",
            o: "offset",
            q: "in_pubstock"
        };

        const result = {};
        const path = _url;
        const segments = path.split("/");
        const filterIndex = segments.indexOf("filter");
        if (filterIndex === -1) return result;

        for (let i = filterIndex + 1; i < segments.length; i += 2) {
            const key = segments[i];
            const value = segments[i + 1];
            if (_map) {
                if (mapping[key] && value !== undefined) {
                    result[mapping[key]] = decodeURIComponent(value);
                }
            } else {
                if (key && value !== undefined) {
                    if (key === "t" || key === "q" || key === "l" || key === "o") {
                        result[key] = decodeURIComponent(value);
                    } else {
                        result[key] = [decodeURIComponent(value)];
                    }
                }
            }
        }
        return result;
    }

    const [searchFilters, setSearchFilters] = useState(parseURL(loc.pathname, false))

    const fetchBusinessDirectory = () => {
        setLoading(true);
        let _obj = parseURL(loc.pathname)

        if (!_obj.offset) {
            _obj.offset = 0;
        }

        apiCall("business_directory/get", _obj, (_s, _r) => {
            if (_s) {

                setResults(_r);
                setFilters(_r.filters);
                if (_obj.offset === 0) {
                    setPagination({ ...pagination, "offset": 0, "current": 1 })
                }
                setSearchFilters(parseURL(loc.pathname, false))
            } else {
                message.error(_r.error)
            }
            setLoading(false);
        })
    }

    useEffect(fetchBusinessDirectory, [loc.pathname]);

    const drawChildTable = (_record) => {
        return (
            <>
                <div className="hideHover" style={{ "marginTop": "-7px", "marginLeft": "-8px", "marginRight": "-8px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "0px 8px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            {(expanded && <div><BusinessContactInfo data={_record} /></div>)}
                        </Renderer>
                    </div>
                </div>
            </>
        )
    }

    const expandCell = (_data) => {
        if (!expanded.includes(_data.id)) {
            setExpanded([_data.id]);
        } else {
            setExpanded([]);
        }
    }

    const drawDetails = () => {
        return results.rows.map(item => {
            return (
                <div>
                    <BusinessContactInfo data={item} />
                    <Divider />
                </div>
            )
        })
    }

    const drawList = () => {

        const columns = [
            {
                title: <small>Name</small>, dataIndex: 'name', key: 'name', render: (e, f) => {
                    return (e) ? <a onClick={() => expandCell(f)}>{e}</a> : "";
                }
            },
            { title: <small>SAN</small>, dataIndex: 'san', key: 'san' },
            { title: <small>City</small>, dataIndex: 'city', key: 'city' },
            { title: <small>Prov.</small>, dataIndex: 'prov', key: 'prov' },
            { title: <small>Country</small>, dataIndex: 'country', key: 'country' },
            {
                title: <small>Category / Specialty</small>, dataIndex: 'categories', key: 'categories', render: (e) => {
                    if (Array.isArray(e) && e.length > 0) {
                        return e[0].category + "/" + e[0].specialty;
                    }
                }
            }
        ]

        return (
            <div>
                <div style={{ minWidth: 'auto' }}>
                    <Table
                        rowKey="id"
                        size="small"
                        columns={columns}
                        className={"fullTable"}
                        dataSource={results.rows}
                        pagination={false}
                        expandable
                        expandedRowKeys={expanded}
                        expandIconColumnIndex={-1}
                        onExpand={(e) => { return false; }}
                        expandIcon={() => { return (<></>) }}
                        expandedRowRender={((record) => drawChildTable(record))}
                    />
                </div>
            </div>
        );
    }


    return (
        <div className="container">
            <div className="float-flex">
                <Space align="center"><Typography.Title style={{ "marginBottom": "6px" }} level={4}>Business Directory</Typography.Title><span style={{ "fontSize": "14px", "opacity": "0.8" }}>({results?.row_count ?? 0})</span></Space>
                <div>
                    <Segmented onChange={(e) => setView(e)} value={view} size="small" options={[
                        {
                            value: 'details',
                            icon: <PicLeftOutlined style={{ "fontSize": "13px" }} />,
                        },
                        {
                            value: 'list',
                            icon: <UnorderedListOutlined style={{ "fontSize": "13px" }} />,
                        }
                    ]}
                    />
                </div>
            </div>
            <Spin spinning={loading}>
                <div>
                    <div><BrowseFilters create={<><Checkbox onChange={(e) => {
                        history.push({ pathname: path + objectToPath({ ...searchFilters, "q": (e.target.checked) ? "true" : "", "o": 0 }) });
                    }} checked={searchFilters.q}>In Pubstock</Checkbox></>} multiple={false} path={path} searchFilters={searchFilters} setSearchFilters={setSearchFilters} setFilters={setFilters} filters={filters} /></div>
                    <div className="shim" />
                    <Divider style={{ "margin": "0px 0px" }} />
                    <Layout>
                        <Layout.Content style={{ "backgroundColor": "#fff" }}>
                            <div className="shim" /><div className="shim" />
                            <Paginate key={"paginate-1"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...searchFilters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                            <Divider key={"divider-1"} dashed style={{ "margin": "10px 0px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />
                            {(view === "details" && <div>{drawDetails()}</div>)}
                            {(view === "list" && <div>{drawList()}</div>)}
                            <Divider key={"divider-2"} dashed style={{ "margin": "10px 20px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />
                            <Paginate key={"paginate-2"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...searchFilters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                        </Layout.Content>
                    </Layout>
                </div>
            </Spin>
        </div>
    )
}